export default __webpack_public_path__ + "static/media/arrow-down-new.fba44849.svg";